export var WithdrawPointTarget;
(function (WithdrawPointTarget) {
    WithdrawPointTarget["GENERAL"] = "general";
    WithdrawPointTarget["ACTIVITY"] = "activity";
    WithdrawPointTarget["GAME"] = "game";
})(WithdrawPointTarget || (WithdrawPointTarget = {}));
//# sourceMappingURL=WithdrawPointTarget.js.map